import { lazy, Suspense } from "react";

// Defers recharts+d3 (~2MB raw) into an async chunk. Charts use
// ResponsiveContainer (client-sized, empty on the server), so rendering the
// null fallback during SSR and loading after hydration is not a regression.
const ChallengeChartsImpl = lazy(() => import("./ChallengeCharts.impl"));

const ChallengeCharts = (props) => (
  <Suspense fallback={null}>
    <ChallengeChartsImpl {...props} />
  </Suspense>
);

export default ChallengeCharts;
